import React from 'react';

const ChatFooter = ({ onEndConversation, isDisabled, hasMessages }) => (
    <div className="roxy-panel__footer">
        <button
            type="button"
            className="roxy-panel__end-btn"
            onClick={onEndConversation}
            disabled={isDisabled || !hasMessages}
        >
            End Conversation
        </button>
    </div>
);

export default ChatFooter;
